module.exports = __webpack_public_path__ + "img/small-18.64b57bf7.webp";